import { Controller } from "@hotwired/stimulus"

// The footer's "Analytics preferences" link: opens the consent banner again (see
// analytics_consent_controller.js), which listens for this event on the window.
export default class extends Controller {
  open(event) {
    event.preventDefault()
    window.dispatchEvent(new CustomEvent("analytics-consent:reopen"))
  }
}
